import {composeSync} from './ToolsJs'
import  {EventBinder} from './ToolsDom'
import  {addStyling, toggleStyling} from './ToolsStyling'

export let utilities = {composeSync, EventBinder, addStyling, toggleStyling};
